var React = require('react');

function OpenBusiness (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.4736 1.26622C3.81527 1.26622 4.09249 0.989105 4.09249 0.647318C4.09249 0.305531 3.81527 0.0284195 3.4736 0.0284195H0V11.9999H5.36683H5.98573H11.3526C11.6942 11.9999 11.9715 11.7227 11.9715 11.381V7.90736H10.7337V10.7621H5.98573H5.36683H1.23777V1.26622H3.4736Z","fill":"#00336F","key":0}),React.createElement("path",{"d":"M5.33402 7.58146L10.7051 2.21038L10.7049 5.88301C10.7049 6.24051 10.9948 6.53034 11.3523 6.53034C11.7098 6.53034 11.9998 6.24053 11.9998 5.88301L12 9.13503e-05L6.11662 0C5.75912 0 5.46918 0.289809 5.46918 0.647331C5.46918 1.00485 5.7591 1.29466 6.11662 1.29466L9.78959 1.29478L4.4183 6.66595L5.33402 7.58146Z","fill":"#00336F","key":1})]);
}

OpenBusiness.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = OpenBusiness;

OpenBusiness.default = OpenBusiness;
